import { render, staticRenderFns } from "./IdentifyYourGargoyles.vue?vue&type=template&id=57c7d578&scoped=true"
import script from "./IdentifyYourGargoyles.vue?vue&type=script&lang=js"
export * from "./IdentifyYourGargoyles.vue?vue&type=script&lang=js"
import style0 from "./IdentifyYourGargoyles.vue?vue&type=style&index=0&id=57c7d578&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c7d578",
  null
  
)

export default component.exports